import { useMemo } from 'react';
import { findModuleDefinition } from '@platform/modularity/moduleDefinitionRegistry';
import { useModuleDefinition } from '@platform/modularity/useModuleDefinition';
import { ModuleStringsProvider } from '@platform/modularity/ModuleStringsProvider';
import { useModuleStrings } from '@platform/modularity/useModuleStrings';
import { useWorkspaceParams } from '@platform/hooks/useWorkspaceParams';
import { NewRecordPage } from './create/NewRecordPage';
import { NEW_RECORD_ID } from './create/newRecordId';
import { SavedRecordPage } from './SavedRecordPage';
import { withPackageExtras } from './withPackageExtras';
import './recordPage.css';

/**
 * Сторінка запису (UIUX forms/form-structure, layout/breadcrumbs; прототип v4): смуга крихт «Простір › Група › Модуль (› Таблиця) ›
 * Тип номер» над вмістом, що прокручується, і бічна панель праворуч; …/<сутність>/new — повна форма нового запису в режимі редагування.
 * Визначення — серверне з ознаками пакета, яких сервер ще не віддає (withPackageExtras). Надає рядки модуля дереву.
 */
export function RecordPage() {
  const { ws, module: moduleKey, rt: rtKey, id, tab } = useWorkspaceParams();
  const { data: server } = useModuleDefinition(moduleKey);
  const module = useMemo(() => server && withPackageExtras(server, findModuleDefinition(moduleKey)), [server, moduleKey]);
  const strings = useModuleStrings(moduleKey);
  const rt = module?.recordTypes.find((r) => r.key === rtKey);
  return (
    <ModuleStringsProvider strings={strings}>
      <div className="rec">
        {id === NEW_RECORD_ID
          ? <NewRecordPage ws={ws} moduleKey={moduleKey} rtKey={rtKey} module={module} rt={rt} />
          : <SavedRecordPage ws={ws} rtKey={rtKey} id={id} tab={tab ?? ''} module={module} rt={rt} />}
      </div>
    </ModuleStringsProvider>
  );
}
